import { ButtonPrimeReact } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Modal from "common/components/Modal/Modal"
import createImgURI from "common/utils/createImgURI"
import {
  formatCurrency,
  formatCurrencyWithDecimal,
} from "common/utils/currency"
import { getDocumentLabel } from "features/Crear/pages/FormCreacionDocumento/constant"
import { useTranslation } from "react-i18next"
import { ArticuloSelectedProps } from "../../SelectedArticlesDocument"

interface CarritoArticulosProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  values: $TSMigrationFixMe
  setFieldValue: (
    field: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: $TSMigrationFixMe,
    shouldValidate?: boolean
  ) => Promise<void>
  handleChangeCantidad: (evento: {
    articulo: string
    sum?: boolean
    cantidad?: string
  }) => void
  agregarCantidad: (evento: {
    articulo: string
    sum?: boolean
    cantidad?: string
  }) => void
  handleDelete: (id: string) => void
}

const CarritoArticulosDocumento = ({
  values,
  setFieldValue,
  handleChangeCantidad,
  agregarCantidad,
  handleDelete,
}: CarritoArticulosProps) => {
  const { t } = useTranslation()
  return (
    <Modal
      visible={values.modals.showModalCarrito}
      header={
        <div className='tw-w-auto tw-flex tw-flex-row tw-items-center'>
          <FontAwesomeIcon
            icon={["fal", "cart-shopping"]}
            className='tw-w-6 tw-h-6'
          />
          <span className='tw-ml-3'>{t("carrito.title")}</span>
        </div>
      }
      onHide={() => setFieldValue("modals.showModalCarrito", false)}
      closable
      footer={
        <div className='tw-w-full tw-flex tw-flex-row tw-items-center tw-px-6 tw-justify-between tw-pt-2'>
          <span className=''>
            {t("carrito.totalArt")}: {values.conceptos.length}
          </span>
          <div className='tw-flex tw-flex-row tw-h-12 tw-items-center tw-text-xl'>
            <div className='tw-flex tw-flex-row tw-font-medium tw-items-center tw-mr-4'>
              <p className='tw-m-0 tw-mr-3 tw-text-nowrap'>
                {t("carrito.totalPre")}:
              </p>
              <span className='tw-text-secondary tw-font-medium'>
                {formatCurrencyWithDecimal(values.total, false, values?.divisa)}
              </span>
            </div>
            <ButtonPrimeReact
              disabled={!values.conceptos.length}
              className='!tw-bg-secondary hover:!tw-shadow-md hover:!tw-bg-secondary-over !tw-border-none tw-text-simple-10 tw-cursor-pointer !tw-w-full tw-ml-3 tw-px-2'
              onClick={() => {
                setFieldValue("documentoType.screen", 3)
                setFieldValue("modals.showModalCarrito", false)
              }}
            >
              {t("carrito.generarLabel")}
              {getDocumentLabel(values.documentoType.type, t)}
            </ButtonPrimeReact>
          </div>
        </div>
      }
      contentClassName='tw-h-[600px]'
      size='normal'
    >
      <div className='tw-w-full tw-min-h-[600px] tw-p-4 tw-bg-neutral-10 tw-rounded-md'>
        {values.conceptos.map((item: ArticuloSelectedProps) => {
          return (
            <div
              key={`${item.concepto}`}
              className='tw-w-full tw-shadow tw-flex tw-flex-row tw-p-6 tw-items-center tw-bg-simple-10 tw-mb-5'
            >
              <div className='!tw-w-24 tw-flex tw-flex-row tw-h-20 tw-items-center tw-p-1'>
                {item.thumbnailBase64 === null ? (
                  <FontAwesomeIcon
                    icon={["fal", "camera-slash"]}
                    className='icon-size-lg'
                  />
                ) : (
                  <img
                    src={createImgURI(item.thumbnailBase64)}
                    alt='imagen'
                    className='tw-w-16 tw-h-16'
                  />
                )}
              </div>
              <div className='tw-flex tw-flex-col tw-flex-1'>
                <div className='tw-flex tw-flex-row tw-flex-1 tw-items-center'>
                  <div className='tw-text-sm tw-px-3 tw-text-neutral-75 tw-text-left'>
                    {item.numeroReferencia}
                  </div>
                  <div className='tw-ml-3 tw-text-lg tw-text-left tw-w-[400px] tw-font-medium tw-truncate'>
                    {item.concepto}
                  </div>
                </div>
                <div className='tw-flex tw-flex-row tw-mt-3 tw-justify-between'>
                  <div className='tw-flex tw-flex-row '>
                    <div className='tw-w-64'>
                      {!values.conceptos.some(
                        (element: ArticuloSelectedProps) =>
                          item.id === element.id
                      ) ? (
                        <div
                          // onClick={() => addArticulo(item)}
                          className='tw-w-full tw-text-nowrap tw-h-12 tw-rounded tw-border tw-border-primary tw-flex tw-justify-center tw-items-center tw-cursor-pointer'
                        >
                          <FontAwesomeIcon
                            className='mr-2'
                            icon={["fal", "cart-shopping"]}
                          />{" "}
                          {t("crear.documento.addArticleLabel")}
                        </div>
                      ) : (
                        <div className='hover:!tw-shadow-md flex items-center justify-start'>
                          <div
                            onClick={() =>
                              agregarCantidad({
                                articulo: item.id as string,
                                sum: false,
                              })
                            }
                            className='flex items-center justify-center py-2 rounded-l shadow-sm w-1-4 border-1 border-gray pointer'
                          >
                            <FontAwesomeIcon
                              className='icon-size-lg'
                              icon={["fal", "minus"]}
                            />
                          </div>

                          <input
                            min={0}
                            value={
                              values.conceptos.find(
                                (element: ArticuloSelectedProps) =>
                                  item.id === element.id
                              ).cantidad
                            }
                            onChange={(e) =>
                              handleChangeCantidad({
                                articulo: item.id as string,
                                cantidad: e.target.value,
                              })
                            }
                            type='number'
                            className='flex items-center justify-center py-2 text-center outarrows w-2-4 bg-bone border-gray border-1'
                          />

                          <div
                            className='flex items-center justify-center py-2 rounded-r shadow-sm w-1-4 border-1 border-gray pointer'
                            onClick={() =>
                              agregarCantidad({
                                articulo: item.id as string,
                                sum: true,
                              })
                            }
                          >
                            <FontAwesomeIcon
                              icon={["fal", "plus"]}
                              className='icon-size-lg'
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    <div
                      onClick={() => {
                        handleDelete(item.id as string)
                      }}
                      className='tw-rounded hover:!tw-shadow-md tw-text-danger tw-w-10 tw-h-10 tw-flex tw-justify-center tw-items-center tw-shadow tw-ml-3 tw-cursor-pointer'
                    >
                      <FontAwesomeIcon
                        icon={["fal", "trash"]}
                        className='tw-w-5 tw-h-5 '
                      />
                    </div>
                  </div>
                  <div className='tw-flex tw-flex-row tw-justify-between tw-items-end'>
                    {!values.config.sinValorar && (
                      <span className='tw-text-xl tw-w-auto tw-text-right tw-mr-3 tw-flex tw-flex-row'>
                        {t("carrito.priceLabel")}
                        {"  "}
                        <span className='tw-font-medium tw-ml-2 tw-text-secondary'>
                          {formatCurrency(
                            item.precioVenta,
                            false,
                            values?.divisa
                          )}
                        </span>
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </Modal>
  )
}

export default CarritoArticulosDocumento
